import {
  CollapseButton,
  DefaultScreenTileBox,
  DefaultScreenTileInnerDivider,
  DistanceBetween,
  LabeledText,
} from '~/common/components/defaultUIComponents';
import { SpecialJob } from '~/common/entities/SpecialJobs/SpecialJobsTypes';
import { Employee } from '~/common/entities/Department/DepartmentTypes';
import { Collapse, Flex, Grid, GridItem } from '@chakra-ui/react';
import { useSpecialJobContext } from './specialJobContext';
import { formatName } from '~/common/utils/employeeUtils';
import SpecialJobInnerTile from './SpecialJobInnerTile';
import React, { useCallback, useMemo } from 'react';

interface SpecialJobInput {
  employee: Employee;
  specialJobs?: SpecialJob[];
}

const SpecialJobTile: React.FC<SpecialJobInput> = ({
  employee,
  specialJobs,
}: SpecialJobInput) => {
  const { openEmployee: openSpecialJob, setOpenEmployee: setOpenSpecialJob } =
    useSpecialJobContext();

  const toggleOpenSpecialJobs = useCallback(() => {
    setOpenSpecialJob(
      openSpecialJob === parseInt(employee.id) ? null : parseInt(employee.id),
    );
  }, [openSpecialJob]);

  const doneAmount = useMemo(() => {
    if (specialJobs) {
      return specialJobs.filter((sp) => sp.done).length;
    }
    return 0;
  }, [specialJobs]);

  return (
    <DefaultScreenTileBox distanceBetweenTiles={DistanceBetween.narrow}>
      <Grid templateColumns="repeat(4, 1fr)">
        <GridItem>
          <LabeledText label={formatName(employee)} fontSize="md" mr={3} />
        </GridItem>
        <GridItem>
          <LabeledText label="specialJobTile.amountOfSpecialJobs">
            {specialJobs?.length}
          </LabeledText>
        </GridItem>
        <GridItem color="red.600">
          {doneAmount > 0 && (
            <LabeledText label="specialJobTile.doneAmount">
              {doneAmount}
            </LabeledText>
          )}
        </GridItem>
        <GridItem>
          <Flex justify="flex-end">
            <CollapseButton
              isOpen={openSpecialJob === parseInt(employee.id)}
              toggleIsOpen={toggleOpenSpecialJobs}
            />
          </Flex>
        </GridItem>
      </Grid>
      <Collapse in={openSpecialJob === parseInt(employee.id)}>
        {specialJobs && specialJobs.length > 0
          ? specialJobs
              .slice()
              .sort((a, b) => {
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);
                return dateB.getTime() - dateA.getTime();
              })
              .map((specialJob, index) => (
                <React.Fragment key={specialJob.id}>
                  {index === 0 && <div style={{ marginTop: '16px' }} />}
                  <SpecialJobInnerTile specialJob={specialJob} employee={employee} />
                  {index < specialJobs.length - 1 ? (
                    <DefaultScreenTileInnerDivider />
                  ) : null}
                </React.Fragment>
              ))
          : null}
      </Collapse>
    </DefaultScreenTileBox>
  );
};

export default SpecialJobTile;
